import { useNavigate } from 'react-router-dom';
import type { CommerceProduct } from '@tailorcast/shared-types';
import { ScoreBadge } from './ScoreBadge';

interface ProductTableProps {
  products: CommerceProduct[];
}

export function ProductTable({ products }: ProductTableProps) {
  const navigate = useNavigate();

  if (products.length === 0) {
    return (
      <div className="text-center py-12 text-gray-500">
        No products found. Try syncing your catalog first.
      </div>
    );
  }

  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b border-gray-200 text-left text-gray-500">
            <th className="pb-3 font-medium">Product</th>
            <th className="pb-3 font-medium">Category</th>
            <th className="pb-3 font-medium text-right">Price</th>
            <th className="pb-3 font-medium text-center">Score</th>
            <th className="pb-3 font-medium text-right">Analyzed</th>
          </tr>
        </thead>
        <tbody>
          {products.map((product) => (
            <tr
              key={product.id}
              onClick={() => navigate(`/products/${product.id}`)}
              className="border-b border-gray-100 hover:bg-gray-50 cursor-pointer"
            >
              <td className="py-3">
                <div className="flex items-center gap-3">
                  {product.images?.[0] && (
                    <img
                      src={product.images[0].url}
                      alt=""
                      className="w-10 h-10 rounded object-cover"
                    />
                  )}
                  <span className="font-medium text-gray-900 truncate max-w-xs">
                    {product.title}
                  </span>
                </div>
              </td>
              <td className="py-3 text-gray-600">{product.category}</td>
              <td className="py-3 text-right text-gray-600">
                {product.price} {product.currency}
              </td>
              <td className="py-3 text-center">
                <ScoreBadge score={product.overallScore} />
              </td>
              <td className="py-3 text-right text-gray-400 text-xs">
                {product.lastAnalyzedAt
                  ? new Date(product.lastAnalyzedAt).toLocaleDateString()
                  : 'Not analyzed'}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
